import chalk from "chalk";
class Sensor {
    constructor(name, callback) {
        this.active = false;
        this.name = name;
        this.callback = callback;
    }
    runCallback(value) {
        if (!this.callback) {
            this.active = !!value;
        }
        else {
            this.active = this.callback(value);
        }
    }
}
/**
 * InstrumentPanel.addSensor("firebase:connected", () => {
 *
 * });
 */
class InstrumentPanelClass {
    constructor() {
        this.sensors = [];
    }
    addSensor(name, callback) {
        if (this.sensors.find(sensor => sensor.name === name)) {
            console.warn(`Sensor ${name} already registered`);
            return;
        }
        let sensor = new Sensor(name, callback);
        this.sensors.push(sensor);
    }
    update(sensorName, value) {
        this.sensors.forEach(sensor => {
            if (sensor.name === sensorName) {
                sensor.runCallback(value);
            }
            else {
                console.log(`Sensor ${sensor.name} not found.`);
            }
        });
    }
    log() {
        console.log("INSTRUMENT PANEL:");
        this.sensors.forEach((sensor) => {
            let msg;
            if (sensor.active) {
                msg = `\t✓ ${sensor.name}`;
            }
            else {
                msg = chalk.red(`\tx ${sensor.name}`);
            }
            console.log(msg);
        });
    }
}
;
export const InstrumentPanel = new InstrumentPanelClass();
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.InstrumentPanel = InstrumentPanel;
}
export default InstrumentPanel;
//# sourceMappingURL=instrument-panel.js.map